import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const CustomTooltip = styled(({ className, placement, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement={placement} followCursor />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.backgroundColor,
    color: theme.color,
    padding: theme.padding,
    fontSize: theme.fontSize,
    borderRadius: theme.borderRadius
  }
}));
